var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccidentAndIllness(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9808 28.3725L3.59448 16.9165C-3.15524 10.137 6.69162 -2.99212 15.9808 7.62731C25.2699 -2.96012 35.2082 10.1667 28.3648 16.9165L15.9808 28.3725Z",
    fill: "#CDD3FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03158 15.4353H11.5287L13.8876 10.937L17.4601 19.2227L20.5299 15.4353H23.9584",
    fill: "#CDD3FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03158 15.4353H11.5287L13.8876 10.937L17.4601 19.2227L20.5299 15.4353H23.9584M15.9808 28.3725L3.59448 16.9165C-3.15524 10.137 6.69162 -2.99212 15.9808 7.62731C25.2699 -2.96012 35.2082 10.1667 28.3648 16.9165L15.9808 28.3725Z",
    stroke: "#1429B8",
    strokeWidth: 1.16364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccidentAndIllness);
export default __webpack_public_path__ + "static/media/accident-and-illness.7a3e2f3a57b148c39b8693d260209f24.svg";
export { ForwardRef as ReactComponent };